export const getSlidesToShow = (width) => {
    switch (true) {
        case width > 1200: {
            return 4;
        }
        case width > 992: {
            return 3;
        }
        case width > 768: {
            return 2;
        }
        default:
            return 1;
    }
};
